export default __webpack_public_path__ + "static/media/webiner.71973f51.jpg";